import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { useCallback } from 'react'

//TODO this needs to go somewhere else
export enum LinkStatus {
  'unknown',
  'verified',
  'broken',
}

export interface StableLink {
  id: number
  link: string
  opportunityId: number
  eventDate: string
  linkStatus: LinkStatus
}

export const useGetStableLink = (): [(encodedOccurrence: string) => Promise<StableLink>, Status<StableLink>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<StableLink>()

  const getStableLink = useCallback(
    async (encodedOccurrence: string) =>
      request({
        url: `/organizations/${organization.id}/opportunity_instances/${encodedOccurrence}/stable_link`,
      }),
    [request, organization.id],
  )

  return [getStableLink, status]
}
